import { Col, Row } from "react-bootstrap";
import { useState } from "react";
import AdminLayout from "./layout/AdminLayout";
import ImcList from "../components/admin/imc/ImcList";
const ImcModule = () => {
  const [tabValue, setTabValue] = useState("0");
  return (
    <AdminLayout>
      <Row>
        {/* <h1 className="title mb-4">Dashboard</h1> */}
        {/* <Col className="container mb-4">
          <RecentWorkForce/>
          
        </Col> */}
        <Col className={`container mb-4 ${
            tabValue === "0" ? "custom-fit-container" : ""
          }`}>
        <ImcList  tabValue={tabValue} setTabValue={setTabValue} />
        </Col>
      </Row>
    </AdminLayout>
  );
};

export default ImcModule;
